import { Icon } from '@winnin/ds-icon'
import { Button } from '@winnin/winnin_ui.components.button'
import { Title } from '@winnin/winnin_ui.components.title'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './document-error.i18n'
import type { IDocumentError } from './document-error.types'

import './document-error.styles.scss'

export function DocumentErrorView({ onRetry, isLoading }: IDocumentError) {
  const t = useTranslate()

  return (
    <div className="DocumentError">
      <Icon name="info" width={24} height={24} />

      <div className="DocumentError-content">
        <Title tag="h3" weight="semi" className="DocumentError-title">
          {t(translations.title)}
        </Title>

        <p className="DocumentError-description">{t(translations.description)}</p>

        <Button
          className="DocumentError-button"
          appearance="outline"
          variation="white"
          onClick={onRetry}
          disabled={isLoading}
        >
          {t(TOLGEE_GLOBALS.tryAgain)}
        </Button>
      </div>
    </div>
  )
}
